import { gql } from '@apollo/client';

const MATCH_IT_TRASH_IT_ACTIVITY = gql`
  query matchItTrashIt($where: ActivityWhereInput!) {
    matchItTrashIt(where: $where) {
      title
      description
      book {
        id
        title
        characters {
          id
          character
          characterCase
          characterType
        }
      }
      activityType {
        name
      }
      activityTypeId
      url
    }
  }
`;

export default MATCH_IT_TRASH_IT_ACTIVITY;
